/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */

export type AgentExecutionStatus =
  (typeof AgentExecutionStatus)[keyof typeof AgentExecutionStatus];

export const AgentExecutionStatus = {
  INCOMPLETE: "INCOMPLETE",
  QUEUED: "QUEUED",
  RUNNING: "RUNNING",
  COMPLETED: "COMPLETED",
  TERMINATED: "TERMINATED",
  FAILED: "FAILED",
  REVIEW: "REVIEW",
} as const;
